(function () {
  function mount({ gridSelector, view }) {
    const grid = document.querySelector(gridSelector);
    if (!grid) return;
    // Scope the pill-row lookup to this grid's own section — the homepage mounts
    // both box-builder and mini-catalog, each with its own pill bar, and an
    // unscoped document.querySelector would always resolve to the first one.
    const scope = grid.closest("section") || document;
    const parentRow = scope.querySelector('[data-tribe-row="parent"]');
    const childRow = scope.querySelector('[data-tribe-row="child"]');
    if (!parentRow) return;

    // Fragment URLs may already carry ?page=N, so only append view= when it
    // isn't already there.
    const withView = (u) => (u.includes("view=") ? u : u + (u.includes("?") ? "&" : "?") + "view=" + view);

    async function show(url, pushTribe, pushHistory = true) {
      grid.classList.remove("filter-error");
      grid.classList.add("loading");
      try {
        // withView, not blind "?view=" append — pager URLs already carry ?page=N.
        const res = await fetch(withView(url));
        if (!res.ok) throw new Error(res.status);
        grid.innerHTML = await res.text();
        if (pushHistory) {
          const params = new URLSearchParams(location.search);
          pushTribe ? params.set("tribe", pushTribe) : params.delete("tribe");
          history.pushState({ tribe: pushTribe }, "", `${location.pathname}${params.toString() ? "?" + params : ""}`);
        }
        grid.dispatchEvent(new CustomEvent("tribe:swapped", { bubbles: true }));
      } catch (e) {
        grid.classList.add("filter-error");
      } finally {
        grid.classList.remove("loading");
      }
    }

    function renderChildren(pill) {
      const spec = pill && pill.dataset.children;
      childRow.innerHTML = "";
      childRow.hidden = !spec;
      if (!spec) return;
      const all = document.createElement("a");
      all.className = "filter-pill active";
      all.href = pill.href;
      all.dataset.tribe = pill.dataset.tribe;
      all.textContent = `All ${pill.textContent.trim().toLowerCase()}`;
      childRow.appendChild(all);
      spec.split("|").forEach((entry) => {
        const [id, label] = entry.split(":");
        const a = document.createElement("a");
        a.className = "filter-pill";
        a.href = `${pill.href.replace(/\/tribe-[^/]+$/, "")}/tribe-${id}`;
        a.dataset.tribe = id;
        a.textContent = label;
        childRow.appendChild(a);
      });
    }

    function activate(row, pill) {
      row.querySelectorAll(".filter-pill").forEach((p) => p.classList.toggle("active", p === pill));
    }

    [parentRow, childRow].forEach((row) =>
      row.addEventListener("click", (event) => {
        const pill = event.target.closest(".filter-pill");
        if (!pill) return;
        event.preventDefault();
        activate(row, pill);
        if (row === parentRow) renderChildren(pill.dataset.children ? pill : null);
        show(pill.getAttribute("href"), pill.dataset.tribe);
      }),
    );

    function syncTribe(tribe) {
      if (!tribe) {
        const allPill = parentRow.querySelector('[data-tribe=""]');
        activate(parentRow, allPill);
        renderChildren(null);
        show(allPill.getAttribute("href"), "", false);
        return;
      }
      const pill =
        parentRow.querySelector(`[data-tribe="${CSS.escape(tribe)}"]`) ||
        [...parentRow.querySelectorAll("[data-children]")].find((p) =>
          (p.dataset.children || "").split("|").some((c) => c.split(":")[0] === tribe),
        );
      // No pill matches this tribe (e.g. an unmatched ?tribe= deep link) —
      // keep the server-rendered first page, which already carries its pager.
      if (!pill) return;
      activate(parentRow, pill);
      renderChildren(pill.dataset.children ? pill : null);
      const target = childRow.querySelector(`[data-tribe="${CSS.escape(tribe)}"]`) || pill;
      if (childRow) activate(childRow, target);
      show(target.getAttribute("href"), tribe, false);
    }

    // Numbered pager (cards view). Fragment swap like a pill click, but the
    // tribe/history state is untouched — only the page changes.
    grid.addEventListener("click", async (event) => {
      const link = event.target.closest("[data-pager]");
      if (!link) return;
      event.preventDefault();
      await show(link.getAttribute("href"), null, false);
      grid.scrollIntoView({ behavior: "smooth", block: "start" });
    });

    const initial = new URLSearchParams(location.search).get("tribe");
    if (initial) syncTribe(initial);

    window.addEventListener("popstate", () => syncTribe(new URLSearchParams(location.search).get("tribe")));
  }

  window.TribeFilter = { mount };
})();
